
import React from 'react'
import PropTypes from "prop-types";
import {connect} from "react-redux";
import "../resources/css/formulario_responsive.css";
import "../resources/css/alertas.css";

import {
    guardar, postServicio, showSecciones,

} from "../utils/FormularioUtils";

import {loadServicioEntidad} from "../../framework2/ej2/utils/EntidadJPAUtils";
import {Button, Icon, Intent} from "@blueprintjs/core";
import AvisoModalServicio from "../../framework2/ej2/UI/AvisoModalServicio";
import {FlaskConicalIcon} from "lucide-react";
import Tratamientos from "./Tratamientos";
import CitasLista from "./CitasLista";
import Pagos from "./Pagos";
import Documentos, {DOCUMENTOS_MODO_GALERIA, DOCUMENTOS_MODO_GRID, DOCUMENTOS_MODO_TODO} from "./Documentos";
import Consentimientos from "./Consentimientos";



class Paciente extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            elemento: props.elemento,
            activeTab: 'datos',
        }
        this.elementoConfig= props.elementoConfig;
        this.alertaParpadea= true;
    }

    componentDidMount() {
        this.inicializarPaciente();


        setTimeout(() => {
            this.alertaParpadea = false;
            this.forceUpdate();
        }, 5000);
    }

    inicializarPaciente= () => {
        const {elemento} = this.state;
        const{estado} = this.props;

        console.log("INICIALIZAR PACIENTE");
        let parametros= {
            clinicaCodigo: estado.clinica.codigo,
        }
        console.log("estado: ", estado);
        console.log("parametros: ", parametros);

        if (!elemento.codigoid) {
            loadServicioEntidad("Paciente", "getSiguienteCodigoId", parametros, (response) => {
                console.log(response);
                let newCodigoId = response.mensaje;
                console.log("codigoid: ", newCodigoId);

                let newElemento= {...elemento};
                console.log("NEWELEMENTO: ", newElemento);
                newElemento.codigoid= newCodigoId;

                console.log("newElemento: ", newElemento);
                this.setState({elemento: newElemento});
            });
        }
    }


    setTab= (tabName) => {
        this.setState({ activeTab: tabName });
    }


    aceptar= () => {
        const {elemento} = this.state;
        const {estado} = this.props;
        //1. Comprobamos que el codigoId no esté repetido en esa clinica
        let parametros= {codigo: elemento.codigo, clinicaCodigo: estado.clinica.codigo, codigoid: elemento.codigoid};
        postServicio(this, "Paciente", "existeCodigoId", parametros, (response) => this.resultadoExisteCodigoId(response.mensaje === "true"));
    }

    resultadoExisteCodigoId= (existe) => {
        const {elemento} = this.state;
        const {auth, onAceptar} = this.props;
        console.log(">>> resultadoExisteCodigoId");
        console.log("existe: ", existe);

        if (existe){
            AvisoModalServicio.showAviso("El código indicado ya existe previamente");
        }
        else{
            guardar(elemento, auth.usuarioCodigo, this.elementoConfig, onAceptar);
        }

    }

    cancelar= () => {
        //const {elemento} = this.state;
        const {onCancelar} = this.props;

        //Tenemos que comprobar si no es un nuevo paciente con datos.
        /*
        console.log("elemento: ", elemento);
        if (elemento.codigo == 0 && (elemento.nombre !== "" || elemento.dni !== "") ){
            alert ("El nuevo paciente tiene datos pero no ha sido guardado. ¿Desea salir de todas formas? ")
        }
        */
        onCancelar && onCancelar();
    }

    addSalaEspera= (cita) => {
        const {elemento} = this.state;
        const {auth, estado} = this.props;
        let parametros= {
            usuarioCodigo: auth.usuarioCodigo,
            pacienteCodigo: elemento.codigo,
            clinicaCodigo: estado.clinica.codigo,
            destino:0,
        }
        postServicio(this, "Salaespera", "addSalaEspera", parametros, (resultado) => {
            console.log("Resultado: ", resultado);
            if (resultado && Boolean(resultado.exito))
                alert("Paciente en sala de espera");
        });
    }

    renderAlerta = (texto) => {
        return (
            <>
                <span   style={{ marginLeft: '10px', fontSize: '1.4em', color: 'red' }}
                        className={this.alertaParpadea ? "blink" : ""} >
                    &nbsp;⚠️&nbsp;{texto}
                </span>
            </>
        );
    }
    
    render() {
        const {elemento, activeTab} = this.state;
        console.log("RENDER");
        //console.log("activeTab: ", activeTab);
        console.log("elemento: ", elemento);
        //console.log("elemento.alertas: ", elemento.alertas);
        let mostrarAlertas=  (elemento.alertas && elemento.alertas != "") || (elemento.hisAlergias && elemento.hisAlergias != "");
        let textoAlertas= (elemento.alertas ? elemento.alertas: "")  + " " + (elemento.hisAlergias ? elemento.hisAlergias : "");
        console.log(textoAlertas);
        let mostrarAlergias= elemento.hisAlergias && elemento.hisAlergias != "";

        let noEsNuevo= Object.hasOwn(elemento, "codigo");
        console.log("noEsNuevo: ", noEsNuevo);
        console.log( "Boolean(noEsNuevo): ", Boolean(noEsNuevo)  );

        let codigoYNombre = elemento.codigoid + " - " + elemento.nombre;

        //console.log("elemento.alergias: ", elemento.hisAlergias);
        return (
            <>
                <div className="fr_tituloentidad">{codigoYNombre}
                    {/*mostrarAlertas && <span style={{marginLeft: '10px', fontSize: '1.4em', color: 'red'}}>&nbsp;⚠️&nbsp;{elemento.alertas}</span>*/}
                    {/*mostrarAlergias && <span style={{marginLeft: '10px', fontSize: '1.4em', color:'green'}}>&nbsp;⚕️</span>*/}
                    {mostrarAlertas && this.renderAlerta(textoAlertas)}
                    {mostrarAlergias && <FlaskConicalIcon style={{marginLeft: '10px', marginBottom:'-10px'}} size={32} color="red" />}
                    <Button large={true} style={{marginLeft: 100}}  intent={Intent.PRIMARY} text="Volver" icon="undo"
                                onClick={this.cancelar}/>

                </div>
                <div className="container">
                    <div className="tabs">
                        <div className={`tab ${activeTab === 'datos' ? 'active' : ''}`}
                             onClick={() => this.setTab('datos')}><Icon className="tab-icon" icon="people" />Datos personales</div>
                        {Boolean(noEsNuevo) &&
                        <div className={`tab ${activeTab === 'tratamientos' ? 'active' : ''}`}
                             onClick= {() => this.setTab('tratamientos')}><Icon className="tab-icon" icon="lab-test" />Tratamientos</div>
                        }
                        {Boolean(noEsNuevo) &&
                        <div className={`tab ${activeTab === 'citas' ? 'active' : ''}`}
                             onClick= {() => this.setTab('citas')}><Icon className="tab-icon" icon="timeline-events" />Citas</div>
                        }
                        {Boolean(noEsNuevo) &&
                        <div className={`tab ${activeTab === 'pagos' ? 'active' : ''}`}
                             onClick= {() => this.setTab('pagos')}><Icon className="tab-icon" icon="euro" />Pagos</div>
                        }

                        {Boolean(noEsNuevo) &&
                        <div className={`tab ${activeTab === 'documentos' ? 'active' : ''}`}
                             onClick= {() => this.setTab('documentos')}><Icon className="tab-icon" icon="document" />Documentos</div>
                        }

                        {Boolean(noEsNuevo) &&
                        <div className={`tab ${activeTab === 'consentimientos' ? 'active' : ''}`}
                             onClick= {() => this.setTab('consentimientos')}><Icon className="tab-icon" icon="draw" />Consentimientos</div>
                        }
                    </div>

                    {activeTab === 'datos' &&
                        <div id="datos" className="tab-content">
                            <div className="fr_formulario">
                                {showSecciones(elemento, this.elementoConfig.secciones, this)}
                                <button className="fr_boton refrescar" onClick={this.addSalaEspera}>A Sala de espera</button>
                                <button className="fr_boton aceptar" onClick={this.aceptar}>Aceptar</button>
                                <button className="fr_boton cancelar" onClick={this.cancelar}>Cancelar</button>
                            </div>

                        </div>
                    }
                    {activeTab === 'tratamientos' &&
                        <div id="tratamientos" className="tab-content">
                            <Tratamientos paciente={elemento} />
                        </div>
                    }

                    {activeTab === 'citas' &&
                        <div id="citas" className="tab-content">
                            <CitasLista paciente={elemento} />
                        </div>
                    }

                    {activeTab === 'pagos' &&
                        <div id="pagos" className="tab-content">
                            <Pagos paciente={elemento} />
                        </div>
                    }

                    {activeTab === 'documentos' &&
                        <div id="documentos" className="tab-content">
                            <Documentos paciente={elemento}  nombreClase="Paciente" modo={DOCUMENTOS_MODO_TODO} />
                        </div>
                    }

                    {activeTab === 'consentimientos' &&
                        <div id="consentimientos" className="tab-content">
                            <Consentimientos paciente={elemento}  />
                        </div>
                    }

                </div>
            </>
        )
    }


}

Paciente.propTypes = {
    elementoConfig: PropTypes.object,
    elemento: PropTypes.object,
    onAceptar: PropTypes.func,
    onCancelar: PropTypes.func,
}

const mapStateToProps = function(state) {
    console.log ("mapStateToProps ", state);
    return {
        auth: state.auth,
        datosmaestros: state.datosmaestros,
        estado: state.estado,
    }
}
export default connect(mapStateToProps)(Paciente);



